export default __webpack_public_path__ + "static/media/challenge-end.203cd4b2.mp3";